// extracted by mini-css-extract-plugin
export var changeIcon = "_4p-4";
export var clickable = "_4p-8";
export var container = "_4p-0";
export var divider = "_4p-7";
export var externalLinkIcon = "_4p-1";
export var green = "_4p-5";
export var helpCircleIcon = "_4p-3";
export var iconButton = "_4p-2";
export var red = "_4p-6";